import React from 'react';

const SectionTitle = ({ children, level = 2, className = '', icon: Icon }) => {
  const baseClasses = 'font-bold text-gray-900 dark:text-white mb-4';
  
  const levelClasses = {
    1: 'text-3xl md:text-4xl',
    2: 'text-2xl md:text-3xl',
    3: 'text-xl md:text-2xl',
    4: 'text-lg md:text-xl'
  };

  const iconSizes = {
    1: 'h-8 w-8 md:h-10 md:w-10',
    2: 'h-7 w-7 md:h-8 md:w-8',
    3: 'h-6 w-6 md:h-7 md:w-7',
    4: 'h-5 w-5 md:h-6 md:w-6'
  };

  const sizeClass = levelClasses[level] || levelClasses[2];
  const iconSize = iconSizes[level] || iconSizes[2];
  
  // Check if centering is requested
  const isCentered = className.includes('text-center');
  const flexAlignment = isCentered ? 'justify-center' : '';
  
  const Tag = `h${level}`;
  
  return React.createElement(
    Tag,
    { className: `${baseClasses} ${sizeClass} ${className} flex items-center gap-3 ${flexAlignment}` },
    Icon && React.createElement(Icon, { className: `${iconSize} text-teal-600 dark:text-teal-400 flex-shrink-0` }),
    children
  );
};

export default SectionTitle;
